// Facility assessments stored in hefrias (backend: app/Hefrias/CLAUDE.md). Shared helpers for the pages.
import cart from "../marketplace/cart";

export const API = "/api/v1/auth/hefrias";

export const MAX_FILE_MB = 5;
export const FILE_TYPES = ["image/png", "image/jpeg", "application/pdf"];

export function stored(key) {
  try {
    return JSON.parse(localStorage.getItem(key) || "null");
  } catch (e) {
    return null;
  }
}

export function money(v) {
  return "₦" + Number(v || 0).toLocaleString("en-NG", { maximumFractionDigits: 2 });
}

export function errorText(err, fallback) {
  const d = (err && err.response && err.response.data) || {};
  if (d.errors && typeof d.errors === "object") {
    const list = Object.values(d.errors).flat().filter(Boolean);
    if (list.length) return list.join(" ");
  }
  return d.message || fallback;
}

/** Reads a file as a data URI (what hefrias accepts); rejects other types and files over MAX_FILE_MB. */
export function readFile(file) {
  return new Promise((resolve, reject) => {
    if (!FILE_TYPES.includes(file.type)) return reject(new Error(`${file.name}: only PNG, JPEG or PDF files.`));
    if (file.size > MAX_FILE_MB * 1024 * 1024) return reject(new Error(`${file.name} is larger than ${MAX_FILE_MB} MB.`));
    const reader = new FileReader();
    reader.onload = () => resolve({ name: file.name, type: file.type, data: reader.result });
    reader.onerror = () => reject(new Error(`${file.name} could not be read.`));
    reader.readAsDataURL(file);
  });
}

/** Puts an offer in the marketplace cart, at its suggested quantity. */
export function addOfferToCart(offer) {
  cart.add(
    {
      id: offer.vendor_product_id,
      name: offer.name,
      unit: offer.unit,
      unit_price: offer.unit_price,
      min_order_quantity: 1,
      quantity_available: offer.quantity_available,
      image_urls: offer.image_url ? [offer.image_url] : [],
      vendor: offer.vendor || { id: 0, name: "" },
    },
    offer.quantity
  );
}

export function scoreClass(percentile) {
  const p = Number(percentile);
  if (isNaN(p)) return "";
  return p >= 75 ? "score--good" : p >= 50 ? "score--fair" : "score--poor";
}
